import { getStoreBuilder } from "vuex-typex";
import { default as AppSettings, IAppSettings } from "../services/AppSettings";
import { RootState } from "./index";

export interface AppState {
    culture: string;
}

const initialState: IAppSettings = AppSettings.state;
const store = getStoreBuilder<RootState>().module("app", initialState);

function state(currentState: IAppSettings): IAppSettings {
    return currentState;
}

const getState = store.read(state, "state");

export const appStore = {
    get state() { return getState(); }
};
